module.exports = __webpack_public_path__ + "img/transformations-feature-2.e7337cb9.svg";